// extracted by mini-css-extract-plugin
export default {"upload-container":"FilesInput_upload-container__9x8vE","upload-icon":"FilesInput_upload-icon__m+ixG"};